import * as React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { useState, ReactNode } from 'react';
import ExpandOrCollapseButton from '../../appComponents/common/buttons/ExpandOrCollapseButton';
import './SubSection.less';
import { camelizeAll } from '../../lib/utils';

const SubSection = (props: Props) => {
	const [expanded, setExpanded] = useState(!props.initiallyClosed);

	return (
		<section className={classNames('expandableSection', camelizeAll(props.title), props.className)}>
			<h2>
				{props.title}
				{props.icon && <IconWrapper>{props.icon}</IconWrapper>}
			</h2>
			<div className="topBorderDivider">
				{props.collapsable && <ExpandOrCollapseButton expanded={expanded} onClick={() => setExpanded(!expanded)} />}
				{expanded && props.children}
			</div>
		</section>
	);
};

interface Props {
	title: string;
	className?: string;
	children?: ReactNode;
	collapsable?: boolean;
	initiallyClosed?: boolean;
	icon?: JSX.Element;
}

SubSection.defaultProps = {
	className: null,
	children: null,
	collapsable: true,
	initiallyClosed: false,
	icon: null
};

export default SubSection;

const IconWrapper = styled.span`
	position: relative;
	/* If the height the icon is not 16px, then this rule will not vertically center the icon */
	top: -3px;
`;
